import { LocalStorageEnum } from "./enums";

export default class LS {
  static LStorage: Storage;
  static cartVersions: LocalStorageEnum[];
  static latestCartVersion: LocalStorageEnum;

  static defineLStorage() {
    const isBrowser = typeof window !== "undefined";

    if (!isBrowser) {
      return;
    }
    if (LS.LStorage === null || LS.LStorage === undefined) {
      LS.LStorage = window.localStorage;
    }
    this.cartVersions = [
      LocalStorageEnum.CARTV1,
      LocalStorageEnum.CARTV2,
      LocalStorageEnum.CARTV3,
    ];
    this.latestCartVersion = this.cartVersions[this.cartVersions.length - 1];
  }

  static _get(key: LocalStorageEnum, parse: boolean = false) {
    LS.defineLStorage();
    let returned: any = LS.LStorage?.getItem(key);
    if (returned) {
      returned = parse === true ? JSON.parse(returned) : returned;
    }

    return returned;
  }

  static _set(key: LocalStorageEnum, value: any, stringify: boolean = false) {
    LS.defineLStorage();
    if (stringify) {
      LS.LStorage.setItem(key, JSON.stringify(value));
    } else {
      LS.LStorage.setItem(key, value);
    }
  }

  static _delete(key: LocalStorageEnum) {
    LS.defineLStorage();
    LS.LStorage.removeItem(key);
  }

  static _clearItems(keys: LocalStorageEnum[]) {
    LS.defineLStorage();
    if (keys.length > 0) {
      keys.forEach((key) => LS._delete(key));
    } else {
      LS.LStorage.clear();
    }
  }

  static _checkLocalStorageIfBlocked() {
    try {
      window.localStorage;

      return false;
    } catch (error) {
      if (`${error}` === "SecurityError: The operation is insecure.") {
        console.log("can't access local storage", error);

        return true;
      }

      return false;
    }
  }
}
